import { combineReducers } from 'redux'
import config from './config'
import donate from './donate'

export default combineReducers({
  config,
  donate
})
